const elevationFAQData = [
    {
      question: "What is building elevation?",
      answer: "Building elevation refers to the vertical view of a building's exterior from a straight-on perspective. It shows the building's height, architectural features, and the relationship between different levels.",
    },
    {
      question: "Why are elevation drawings important?",
      answer: "Elevation drawings are crucial for visualizing the finished appearance of a building, ensuring accurate construction, and communicating design intent to builders and clients. They help in understanding the building's scale, proportions, and aesthetic details.",
    },
    {
      question: "What are the different types of elevation drawings?",
      answer: "Common types include front elevation, rear elevation, side elevations (left and right), and interior elevations. Each type provides a specific view of the building from a different direction.",
    },
    {
      question: "How are building elevations used in construction?",
      answer: "Builders use elevations to determine the correct placement of windows, doors, and other architectural elements. They also use them to ensure accurate wall heights, roof slopes, and overall building dimensions.",
    },
    {
      question: "What information is typically included in an elevation drawing?",
      answer: "Elevation drawings usually include dimensions, materials, window and door details, roof slopes, floor levels, and any other relevant architectural features.",
    },
    {
      question: "Can elevation drawings be modified after construction starts?",
      answer: "Modifying elevation drawings after construction starts can be costly and time-consuming. It's best to finalize the design before construction to avoid changes.",
    },
    {
      question: "How do elevation drawings differ from floor plans?",
      answer: "Floor plans show a horizontal view of the building's layout, while elevation drawings show a vertical view of the building's exterior. Floor plans focus on room arrangement, while elevations focus on the building's appearance.",
    },
    {
      question: "Are elevation drawings required for building permits?",
      answer: "Yes, elevation drawings are typically required for building permits. They provide local authorities with a clear understanding of the building's design and ensure compliance with building codes and regulations.",
    },
    {
      question: "What is the difference between an elevation and a section drawing?",
      answer: "An elevation drawing shows the exterior view of a building, while a section drawing shows a 'cut-through' view, revealing the building's interior construction details.",
    },
    {
      question: "How do I read an elevation drawing?",
      answer: "Start by identifying the view (front, rear, side). Look for dimensions, material indications, and details of windows, doors, and roof slopes. Understand the relationship between different levels and features.",
    },
  ];
  
  export default elevationFAQData;